//QueryStrings
function getUrlParam(sParam) {
      var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? false : decodeURIComponent(sParameterName[1]);
        }
      }
	  return(false);
}
//FXR Popups
function fxrPopUp(theContent, theId='fxrPopUp'){
  $(".fxrPopUp#"+theId).remove();
  $('body').css({'overflow': 'auto', 'position': 'static', 'top': 'auto', 'right': 'auto', 'bottom': 'auto', 'left': 'auto'});
  $('body').append('<style></style><div class="fxrPopUp" id="'+theId+'" style=""><div class="fxrPopUpContent" style=""><img class="fxrPopUpX" src="https://cdn.shopify.com/s/files/1/0243/3479/4830/files/fxr-x-button.png?v=1585934775" style=""></div></div>');
    $(".fxrPopUpX").click(function() {
      closeFxrPopUp(theId);
    });
  
    $('.fxrPopUp').on('click', function(e) {
      if (e.target == this)
        closeFxrPopUp(theId);
    });
  
  
  	$('body').css({'overflow': 'hidden', 'position': 'fixed', 'top': '0', 'right': '0', 'bottom': '0', 'left': '0'});
  	$(".fxrPopUp#"+theId+" .fxrPopUpContent").prepend(theContent);
}
//close FXR Popups
function closeFxrPopUp(theId){
	$(".fxrPopUp#"+theId).remove();
	$('body').css({'overflow': 'auto', 'position': 'static', 'top': 'auto', 'right': 'auto', 'bottom': 'auto', 'left': 'auto'});
}

$( document ).ready(function(){
  	//flag dropdown
    $('ul.flagSelectDropdown').on('click touchstart', function(){

        console.log('yep');
        $('li ul:first',this).fadeToggle( "fast", "linear" );

    });

    $(document).on("click", function(event){
        var $trigger = $("ul.flagSelectDropdown");
        if($trigger !== event.target && !$trigger.has(event.target).length){
            $('.sub_menu',this).fadeOut( "fast", "linear" );
        }
    });

  	//configure manual popups
  	//featherlightConf={
		//type: 'html',
		//beforeContent: function(event){
		//	$("div.featherlight").css("background", "rgba(0,0,0,.5)")
		//}
	//};
  	//attach email popup to menu item
  	//$( ".Footer__Inner li a:contains('Signup')" ).click(function(event) {
      	//event.preventDefault();
    	//$.featherlight(fxrNewsletterPopup,featherlightConf);
    //});
//show product share on product page
$( ".fxrProductShareButton" ).click(function(event) {
  $( ".fxrProductShareList" ).fadeToggle();
})


});

// Collection tile full-box link (fxr-collection-item-sq snippet): clicking anywhere on the
// tile navigates to its primary link, but clicking one of the CollectionItem__Link buttons
// still follows that button's own href instead.
document.addEventListener('click', function (event) {
  var wrapper = event.target.closest('.CollectionItem__Wrapper[data-block-link]');
  if (!wrapper) return;
  if (event.target.closest('.CollectionItem__Link')) return;
  var href = wrapper.getAttribute('data-block-link');
  if (href) window.location.href = href;
});

//js version of handleize
handleize = function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};
onewordize = function (str) {
    return str.replace(/[^\w\u00C0-\u024f]+/g, "");
};
spacetohyphens = function (str) {
    return str.replace(/\s/g, "-");
};


//remove gorgias branding from chat
var gorgiasChatInterval = window.setInterval(function () {
  var iframe = document.querySelector('#gorgias-web-messenger-container');
    if (iframe) {
      var head = iframe.contentWindow.document.querySelector('head')
      if (head.children.length) {
        window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.
        var styles = document.createElement('style');
        //styles.textContent = '#messenger-button {left: 20px; right: auto;} .logo-wrapper{display: none;}';
        styles.textContent = '.logo-wrapper{display: none;}'
        head.appendChild(styles)
      }
    }
}, 100);
